// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/v0.1.1248/css/" + chunkId + "." + {"72":"5e26ce48","200":"5e26ce48"}[chunkId] + ".chunk.css";
};